import { useEffect, useRef } from 'react';
import type { ISchedulerData } from '@interfaces/IScheduler';
import { useSchedulerActions } from '../../SchedulerPage/hooks/useSchedulerStore';

/**
 * Loads the schedule on screen into the scheduler store, so the shared
 * TaskPanel (and anything reading a task's step) has live task data. Guarded
 * by (site, schedule) identity — like SchedulerPage — so a background refetch
 * that yields a fresh reference for the SAME schedule doesn't re-bootstrap.
 */
export function useBootstrapSchedule(
  siteId: string | undefined,
  detail: Omit<ISchedulerData, 'siteId'> | undefined,
  scheduleNumber: string | undefined,
) {
  const { bootstrap } = useSchedulerActions();
  const loadedKeyRef = useRef<string | null>(null);
  useEffect(() => {
    if (!detail || !siteId || !scheduleNumber) return;
    const loadedKey = `${siteId}::${scheduleNumber}`;
    if (loadedKeyRef.current === loadedKey) return;
    loadedKeyRef.current = loadedKey;
    bootstrap({ ...detail, siteId });
  }, [detail, siteId, scheduleNumber, bootstrap]);
}
